(ns ui.sticker-dialogs.register
  "UI register of the sticker-dialogs slice: the Replicant sticker
   dialogs of editor2 and their action handlers. Each sticker namespace
   brings its own `register` (its modal and its handlers), next to the
   handlers all dialogs share. The modals keep the ids of the Reagent
   dialogs they replaced (`:modals/editor2-*-modal`), which the editor2
   call sites open."
  (:require [ui.sticker-dialogs.actions :as actions]
            [ui.sticker-dialogs.countdown :as countdown]
            [ui.sticker-dialogs.emoji-picker :as emoji-picker]
            [ui.sticker-dialogs.emoji-slider :as emoji-slider]
            [ui.sticker-dialogs.hashtag :as hashtag]
            [ui.sticker-dialogs.link :as link]
            [ui.sticker-dialogs.location :as location]
            [ui.sticker-dialogs.mention :as mention]
            [ui.sticker-dialogs.poll :as poll]
            [ui.sticker-dialogs.question :as question]
            [ui.sticker-dialogs.quiz :as quiz]))

(def register
  (concat actions/handlers
          emoji-picker/handlers
          hashtag/register
          mention/register
          location/register
          poll/register
          quiz/register
          countdown/register
          question/register
          emoji-slider/register
          link/register))
